import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
import './registerServiceWorker'

const urlParams = new URLSearchParams(window.location.search);
let sol = ""
let admin = false
if (urlParams.has('s')) {
  sol = urlParams.get('s')
  localStorage.movil = sol
}
if (urlParams.has('a') && urlParams.get('a')=="OcnHieQQ33939msu**") {
  admin = true
}
if(!admin && !urlParams.has('s') && localStorage.movil){
    sol = localStorage.movil;
}
const socket = io('https://admin.daalicia.bar', { query: `sol=${sol}&admin=${admin}` });

Vue.use(VueSocketIOExt, socket)
Vue.config.productionTip = false


new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
